import PropTypes from 'prop-types';
import { Tooltip, IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';

EditIconButton.propTypes = {
  onClick: PropTypes.func,
  tooltipText: PropTypes.string,
  disabled: PropTypes.bool,
};

export default function EditIconButton({ onClick, tooltipText = "Edit", disabled = false }) {
  return (
    <Tooltip title={tooltipText} arrow placement="top">
      <IconButton edge="end" color="secondary" onClick={onClick} disableRipple sx={{ px: 0 }} disabled={disabled}>
        <EditIcon />
      </IconButton>
    </Tooltip>
  );
}
